import { motion } from "framer-motion";
import { Search, Users, Car, Calculator } from "lucide-react";

const STEPS = [
    {
        icon: Search,
        title: "Indiquez votre trajet",
        desc: "Renseignez votre point de départ, votre destination et votre horaire en quelques secondes.",
    },
    {
        icon: Users,
        title: "Trouvez votre Coway",
        desc: "On vous propose des passagers vérifiés qui partent dans la même direction au même moment.",
    },
    {
        icon: Car,
        title: "Partagez le taxi",
        desc: "Montez ensemble dans un taxi ou via les principales plateformes VTC avec des personnes allant dans la même direction.",
    },
    {
        icon: Calculator,
        title: "Organisez vos frais",
        desc: "Coway facilite la mise en relation entre voyageurs afin de rendre les trajets plus simples et plus accessibles.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how"
            data-testid="how-it-works"
            className="relative py-24 lg:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="max-w-3xl">
                    <p className="text-xs text-coway uppercase tracking-[0.3em] font-semibold mb-5">
                        Fonctionnement
                    </p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-slate-900">
                        Un trajet partagé,
                        <br />
                        <span className="text-slate-400">
                            des frais partagés.
                        </span>
                    </h2>
                    <p className="mt-6 text-lg text-slate-600 max-w-xl">
                        Le taxi devient enfin abordable. En quatre étapes, vous
                        rencontrez des voyageurs allant dans votre direction et
                        partagez la course.
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
                    {STEPS.map((step, i) => (
                        <motion.div
                            key={step.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{
                                duration: 0.6,
                                delay: i * 0.08,
                                ease: [0.16, 1, 0.3, 1],
                            }}
                            whileHover={{ y: -6 }}
                            data-testid={`step-${i + 1}`}
                            className="relative p-7 rounded-3xl bg-white border border-slate-200 hover:border-coway/40 transition-colors card-elevated overflow-hidden group"
                        >
                            <div className="absolute inset-0 bg-gradient-to-b from-coway-soft/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                            <div className="relative z-10">
                                <div className="flex items-center justify-between mb-8">
                                    <span className="w-12 h-12 rounded-2xl bg-coway-soft border border-coway/15 flex items-center justify-center">
                                        <step.icon
                                            className="w-5 h-5 text-coway"
                                            strokeWidth={1.8}
                                        />
                                    </span>
                                    <span className="font-display font-black text-3xl text-slate-100">
                                        0{i + 1}
                                    </span>
                                </div>
                                <h3 className="font-display text-xl font-bold tracking-tight text-slate-900">
                                    {step.title}
                                </h3>
                                <p className="mt-3 text-sm text-slate-500 leading-relaxed">
                                    {step.desc}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
